<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Partido" />

    <CreateMatch />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreateMatch from "@/components/Pages/Admin/Matches/view.vue";

export default defineComponent({
  name: "CreateMatchPage",
  components: {
    PageTitle,
    CreateMatch,
  },
});
</script>
